module.exports = __webpack_public_path__ + "static/flowForecasts-65a86892b9776d6c484cc922742cd2f2.png";